import { ExperimentVariants } from '@gumtree/shared/src/types/client-data';
import { getGrowthbookClientSide } from '@gumtree/shell/src/growthbook/init-growthbook';

type FeatureValueFormat = (value: boolean | string | undefined) => ExperimentVariants | '' | 'OFF';

// GrowthBookAdFeatures key exprimentId, value is feature. for exprimentId !== featureKey
export const GrowthBookAdFeatures = {
    'GTB-197': 'GTB-197',
    'service-new-ui': 'service-new-ui',
    'sovrn-switch-duration': 'sovrn-switch-duration',
    'motors-cta-opt': 'motors-cta-opt',
};

export const featuresToKeyValue = (
    features: Record<string, string>,
    format: FeatureValueFormat = (val) => val as ExperimentVariants
) => {
    const growthbookClient = getGrowthbookClientSide();
    if (!growthbookClient) return [];
    return Object.entries(features)
        .map(([exprimentId, feature]) => {
            const value = format(growthbookClient.getFeatureValue(feature, ''));
            if (value === '' || value === 'OFF') return null;
            return [exprimentId, value];
        })
        .filter(Boolean) as string[][];
};
